import {t} from 'i18next';
import moment from 'moment';
import {FileUpload} from 'primereact';
import PropTypes from 'prop-types';
import React from 'react';
import {withTranslation} from 'react-i18next';
import BaseDetailsContainer from '../../baseContainers/BaseDetailsContainer';
import CustomLabel from '../../components/CustomLabel';
import DivContainer from '../../components/DivContainer';
import YesNoDialog from '../../components/YesNoDialog';
//import MapLeaflet from '../../components/base/MapLeaflet';
import InputCalendarRangeComponent from '../../components/inputs/InputCalendarRangeComponent';
import InputCheckboxComponent from '../../components/inputs/InputCheckboxComponent';
import InputSelectButtonComponent from '../../components/inputs/InputSelectButtonComponent';
import InputTextComponent from '../../components/inputs/InputTextComponent';
import InputTextEditorComponent from '../../components/inputs/InputTextEditorComponent';
import HandleChangeUtils from '../../components/utils/HandleChangeUtils';
import FileUploadService from '../../services/FileUploadService';
import GeoService from '../../services/GeoService';
import PartnerService from '../../services/PartnerService';
import SettingService from '../../services/SettingService';
import AppPrefixUtils from '../../utils/AppPrefixUtils';
import StringUtils from '../../utils/StringUtils';
import PartnerCreateRequest from './PartnerCreateRequest';
import PartnerDetailsResponse from './PartnerDetailsResponse';
import ImageUtils from '../../utils/ImageUtils';
import {withRouter} from 'react-router-dom/cjs/react-router-dom.min';
import InputLanguageDropdownComponent from '../../components/inputs/InputLanguageDropdownComponent';

const types = {STATIONARY: 'STATIONARY', ONLINE: 'ONLINE'};

class PartnerContainer extends BaseDetailsContainer {
    constructor(props) {
        super(props, new PartnerService());
        this.fileUploadService = new FileUploadService();
        this.geoSerivce = new GeoService();
        this.state = {
            loading: true,
            elementId: props.elementId,
            locale: props.locale,
            tabActiveIndex: 0,
            showConfirmRemoveDialog: false,
            statusOptions: [],
            markers: [],
            markersInitialized: false,
            zoom: 10,
            initialCoordinates: {
                lat: 54.312795,
                lng: 18.651946,
            },
            type: undefined,
            partnerTypes: [
                {
                    label: t('partner.online'),
                    value: types.ONLINE,
                },
                {
                    label: t('partner.stationary'),
                    value: types.STATIONARY,
                },
            ],
            parterStationaryByCoordinate: false,
            renderPrevLogo: true,
            supportedLocales: [],
            uploadedFile: [],
            selectedFile: undefined,
            choosenDays: [],
            dayTypeOptions: [],
            element: {
                translations: [],
            },
        };
        this.settingService = new SettingService();
        this.fileUploadService = new FileUploadService();
        this.editorRef = React.createRef();
        this.fileUploadRefComponent = React.createRef();
        this.renderLocalLanguages = this.renderLocalLanguages.bind(this);
        this.handleChangeHour = this.handleChangeHour.bind(this);
        this.handleChangeAvailability = this.handleChangeAvailability.bind(this);
        this.markAsFound = this.markAsFound.bind(this);
        this.calculateCoordinates = this.calculateCoordinates.bind(this);
        this.handleChangeCoordinates = this.handleChangeCoordinates.bind(this);
        this.reUpdateElement = this.beforeUpdateElement.bind(this);
        this.handleAddressChange = this.handleAddressChange.bind(this);
        this.updateDateRange = this.updateDateRange.bind(this);
        this.renderAvailabilityHoursPerDay = this.renderAvailabilityHoursPerDay.bind(this);
        this.setMarker = this.setMarker.bind(this);
    }

    translate(key) {
        const {t} = this.props;
        return t(key);
    }
    updateElement(data) {
        this.setState(
            {
                element: PartnerDetailsResponse.copy(data, this.state.element),
            },
            () => {
                this.initAfterSetElement();
            }
        );
    }
    componentDidMount() {
        super.componentDidMount();
        this.blockUi();
        this.initBeforeSetElement();
        // this.setElement();
    }
    initAfterSetElement() {
        const {element} = this.state;
        if (this.props.viewMode === 'NEW' && this.state?.dayTypeOptions.length !== 0) {
            let choosenDays = structuredClone(this.state.dayTypeOptions);
            choosenDays.forEach((el) => {
                el.selected = false;
                el.startAt = undefined;
                el.endAt = undefined;
            });
            this.setState({choosenDays});
        } else if (this.props.viewMode === 'EDIT' || this.props.viewMode === 'VIEW') {
            this.updateDateRange();
        }

        if (element.id) {
            const type =
                StringUtils.isBlank(this.state.element.latitude) || StringUtils.isBlank(this.state.element.city)
                    ? types.ONLINE
                    : types.STATIONARY;
            this.setState(() => ({
                type,
            }));
        }
        this.unblockUi();
    }
    updateDateRange() {
        let choosenDays = structuredClone(this.state.dayTypeOptions);
        const hoursAvailabilities = this.state.element?.hoursAvailabilities;
        if (hoursAvailabilities?.length !== 0) {
            choosenDays.forEach((el) => {
                const foundedDay = hoursAvailabilities?.find((ha) => ha.day === el.enumValue);
                if (foundedDay) {
                    el.id = foundedDay?.id;
                    el.selected = true;
                    el.startAt = moment(foundedDay.startAt, 'HH:mm').toDate();
                    el.endAt = moment(foundedDay.endAt, 'HH:mm').toDate();
                } else {
                    el.id = undefined;
                    el.selected = false;
                    el.startAt = undefined;
                    el.endAt = undefined;
                }
            });
        }

        if (this.state.markers.length === 0 && this.state.element.id) {
            const element = this.state.element;
            const {latitude, longitude} = element;
            if (!StringUtils.isBlank(latitude)) {
                const coordinates = {coordinates: [longitude, latitude]};
                this.markAsFound(coordinates);
                this.setState({
                    parterStationaryByCoordinate: StringUtils.isBlank(element.city),
                });
            }
        }
        this.setState({choosenDays});
    }

    setElement() {
        const {viewMode} = this.props;
        const {elementId, locale} = this.state;
        this.beforeUpdateElement(viewMode, elementId, locale);
    }

    beforeUpdateElement(viewMode, elementId, locale) {
        if (elementId && (viewMode === 'EDIT' || viewMode === 'VIEW')) {
            this.blockUi();
            this.service
                .get(elementId, locale)
                .then((data) => {
                    this.setState({loading: false, locale}, () => this.updateElement(data));
                })
                .catch((err) => {
                    this.handleGetDetailsError(err);
                });
        } else {
            this.setState({loading: false}, this.initAfterSetElement());
        }
    }

    handleRemove() {
        this.setState({
            showConfirmRemoveDialog: true,
        });
    }

    remove(type, costam, target) {
        if (target.value) {
            this.scrollToTop();
            this.service
                .removePartner(this.state.elementId)
                .then(() => {
                    const {backUrl} = this.props;
                    this.blockUi();
                    this.persistMessage('success', '', t('partner.successRemove'));
                    // window.location.href = backUrl;
                    this.props.history.push(backUrl);
                })
                .catch(() => {
                    this.setState({showConfirmRemoveDialog: false});
                    this.showErrorMessage(t('partner.removeError'));
                    this.unblockUi();
                });
        } else {
            this.setState({showConfirmRemoveDialog: false});
        }
    }

    initBeforeSetElement() {
        this.enumService
            .getLocalizedEnumListForLocale('DayType')
            .then((dayTypeOptions) =>
                this.setState(
                    {
                        dayTypeOptions,
                    },
                    () => this.initAfterSetElement()
                )
            )
            .catch(() => {
                this.showErrorMessage(t('error.getEmaili18nError'));
            });

        this.settingService
            .getSupportedLocales()
            .then((supportedLocales) => {
                this.setState(
                    {
                        supportedLocales,
                        element:
                            this.props.viewMode === 'NEW'
                                ? new PartnerCreateRequest(this.props.locale, supportedLocales)
                                : new PartnerDetailsResponse(supportedLocales),
                    },
                    () => {
                        if (this.props.viewMode === 'NEW') {
                            this.setState(() => ({
                                type: types.STATIONARY,
                            }));
                        }
                    }
                );
            })
            .catch(() => {
                this.showErrorMessage(t('error.getSupportedLocalesError'));
            });

        this.settingService
            .getImageSize()
            .then((imgMaxSizeParameter) => {
                this.setState({
                    imgMaxSizeParameter,
                    fileSizeToTranslation: imgMaxSizeParameter * 0.001 + t('global.maxFileSizeUnit'),
                });
            })
            .catch((err) => {
                this.showErrorMessage(err.message);
            });
    }

    handleFormSubmit(event) {
        if (event !== undefined) {
            event.preventDefault();
        }
        let validator = this.validator;
        // TODO: nie mam totalnie pojecia czemu validator w komponenecie InputCalendarRangeComponent nie dziala jak powinien dlatego takie cos tutaj
        let nextStep = true;
        const choosenDays = this.state.choosenDays.filter((cd) => cd.selected);
        choosenDays.forEach((ha) => {
            if (!ha.endAt || ha.endAt < ha.startAt) {
                nextStep = false;
                this.unblockUi();
            }
        });

        if (!nextStep) {
            this.showErrorMessage(t('partner.error.notValidDateEnd'));
            return;
        } else {
            // TODO: nie mam totalnie pojecia czemu validator w komponenecie InputCalendarRangeComponent nie dziala jak powinien dlatego takie cos tutaj

            validator.fields.startAt = true;
        }
        if (validator.allValid()) {
            this.blockUi(this.handleValidForm);
        } else {
            validator.showMessages();
            // rerender to show messages for the first time
            this.scrollToError = true;
            this.forceUpdate();
        }
    }
    prepareHeaderItems() {
        const {backUrl} = this.props;
        return [
            {
                customRenderFunction: this.renderLocalLanguages,
                rendered: true,
                className: 'float-left',
            },
            {
                label: t('global.back'),
                // href: AppPrefixUtils.locationHrefUrl(backUrl),
                onClick: () => {
                    this.props.history.push(AppPrefixUtils.locationHrefUrl(backUrl));
                },
                className: 'gray float-right',
                rendered: true,
            },
        ];
    }
    prepareFooterItems() {
        const {detailUrl, editUrl, locale} = this.props;
        const viewMode = this.viewMode() ? this.viewMode() : this.props.viewMode;
        const editHref = `${editUrl}/${this.state.element?.id}/${locale}`;
        const detailHref = `${detailUrl}/${this.state.element?.id}/${locale}`;
        return [
            {
                label: t('global.save'),
                className: 'float-left',
                onClick: this.handleFormSubmit,
                rendered: viewMode === 'NEW' || viewMode === 'EDIT',
            },
            {
                label: t('global.cancel'),
                // href: AppPrefixUtils.locationHrefUrl(detailHref),
                onClick: () => {
                    this.props.history.push(AppPrefixUtils.locationHrefUrl(detailHref));
                },
                className: 'gray',
                rendered: viewMode === 'EDIT',
            },
            {
                label: t('global.edit'),
                // href: AppPrefixUtils.locationHrefUrl(editHref),
                onClick: () => {
                    this.props.history.push(AppPrefixUtils.locationHrefUrl(editHref));
                },
                iconName: 'mdi-pencil',
                className: 'float-right',
                rendered: this.props.viewMode === 'VIEW',
            },
            {
                label: t('global.remove'),
                onClick: this.handleRemove.bind(this),
                className: 'float-right',
                iconName: 'mdi-delete',
                rendered: this.props.viewMode === 'VIEW' || this.props.viewMode === 'EDIT',
            },
        ];
    }

    getContainerListName() {
        return 'partner-list-container';
    }

    getAddSucces() {
        return t('partner.createdMessage');
    }

    getRemoveSucces() {
        return t('partner.removedMessage');
    }

    getUpdateSucces() {
        return t('partner.updatedMessage');
    }

    prepareElementBeforeRequest(element) {
        const choosenDays = this.state.choosenDays
            .filter((el) => el.selected)
            .map((el) => {
                el.day = el.enumValue;
                el.startAt = moment(el.startAt).format('HH:mm');
                el.endAt = moment(el.endAt).format('HH:mm');
                return el;
            });
        const uploadedFile = this.state.uploadedFile;
        if (uploadedFile?.uuid) {
            element.logo = uploadedFile;
            element.logoUuid = uploadedFile?.uuid;
            element.newLogo = true;
        } else {
            element.logoUuid = element?.logo?.uuid;
            element.newLogo = false;
        }
        element.translations = Object.assign({}, element.translations);
        if (this.state.type === 'ONLINE') {
            element.latitude = undefined;
            element.longitude = undefined;
            element.link = undefined;
            element.city = undefined;
            element.streetName = undefined;
            element.streetNumber = undefined;
            element.houseNumber = undefined;
            element.postalCode = undefined;
            element.hoursAvailabilities = [];
        } else {
            element.hoursAvailabilities = choosenDays;
        }

        return element;
    }

    createOrUpdate() {
        const {element} = this.state;
        const {elementId} = this.state;
        const request = this.prepareElementBeforeRequest(element);

        if (!request?.logo) {
            this.showErrorMessage(t('partner.error.noLogoChoosed'));
            this.unblockUi();
            this.updateDateRange();
            return;
        }
        if (element.type === types.STATIONARY && (!request?.latitude || !request?.longitude)) {
            this.showErrorMessage(t('partner.error.noLocalizationFound'));
            this.unblockUi();
            this.updateDateRange();
            return;
        }
        if (this.state.parterStationaryByCoordinate) {
            element.city = undefined;
            element.streetName = undefined;
            element.streetNumber = undefined;
            element.houseNumber = undefined;
            element.postalCode = undefined;
        }

        this.scrollToTop();
        if (this._isMounted) {
            if (!elementId) {
                this.service
                    .add(request)
                    .then((response) => {
                        this.afterAddSuccess(response);
                    })
                    .catch((err) => {
                        this.showErrorMessage(err.message, 10000);
                        // TODO: initAfterSetElement zagadka dlaczego trzeba to tutaj robic...
                        this.initAfterSetElement();
                    });
            } else {
                this.service
                    .update(request)
                    .then((response) => {
                        this.afterUpdateSuccess(response);
                    })
                    .catch((err) => {
                        this.showErrorMessage(err.message, 10000);
                        this.initAfterSetElement();
                    });
            }
        }
    }

    renderLocalLanguages() {
        return (
            <InputLanguageDropdownComponent
                id='locale'
                name='locale'
                label={t('global.languageChooser')}
                validator={this.validator}
                validators='not_required'
                value={this.state?.locale}
                options={this.state?.supportedLocales}
                colClass='col-lg-2 col-md-3 col-sm-3'
                viewMode={'EDIT'}
                onChange={this.handleChange}
                onAfterStateChange={() => {}}
                rendered
                showClear={false}
                stateField={``}
            />
        );
    }

    getBackLabel() {
        return t('global.backToList');
    }

    render() {
        return (
            <div className='container-fluid'>
                {this.renderView()}
                <YesNoDialog
                    onChange={this.remove.bind(this)}
                    visible={this.state.showConfirmRemoveDialog}
                    header={t('partner.removeTitle')}
                    name='visible'
                    onHide={() => {
                        this.setState({showConfirmRemoveDialog: false});
                    }}
                >
                    {' '}
                </YesNoDialog>
            </div>
        );
    }

    breadCrumbItems() {
        return [
            {name: t('partner.listName'), url: '/partner-list'},
            {name: t('partner.details'), url: ``},
        ];
    }

    handleChangeAvailability(a, b, e) {
        let choosenDays = this.state.choosenDays;
        choosenDays.forEach((el) => {
            if (el.enumValue === e.target.name) {
                el.selected = e.target.checked;
            }
        });
        this.setState({choosenDays});
    }

    handleChangeHour(a, b, e, enumValue) {
        let choosenDays = this.state.choosenDays;
        choosenDays.forEach((el) => {
            if (el.enumValue === enumValue) {
                if (e.target.id === `startAt`) {
                    el.startAt = e.target.value;
                    if (el.startAt >= el.endAt || !el.endAt) {
                        el.endAt = el.startAt;
                    }
                } else {
                    el.endAt = e.target.value;
                }
            }
        });

        this.setState({choosenDays});
    }

    renderAvailabilityHoursPerDay() {
        return this.state.choosenDays.map((el, index) => {
            return (
                <div className='row' style={{width: '100%'}}>
                    <InputCheckboxComponent
                        id={`${index}-day`}
                        name={el.enumValue}
                        label={t('')}
                        labelOnRight
                        value={el.selected}
                        validator={this.validator}
                        validators='not_required'
                        colClass='col-md-1'
                        disabled={this.props.viewMode === 'VIEW'}
                        onChange={(a, b, e) => {
                            this.handleChangeAvailability(a, b, e);
                        }}
                        viewMode={'EDIT'}
                        stateField={`element.hoursAvailabilities[${index}]`}
                        positioning='col-md-12 form-group-checkbox-flex'
                    />
                    <InputTextComponent
                        id={`${el.enumValue}-title`}
                        name='title'
                        label={el.label}
                        colClass='col-md-2'
                        validator={this.validator}
                        validators='required|max:255'
                        onChange={this.handleChange}
                        viewMode={'VIEW'}
                    />
                    <InputCalendarRangeComponent
                        key={`${el.enumValue}-hoursDay`}
                        idFrom={`startAt`}
                        idTo={`endAt`}
                        nameTo={`endAt`}
                        nameFrom={`startAt`}
                        label={t('')}
                        labelFrom={t('')}
                        labelTo={t('')}
                        colClass='col-9'
                        from={el.startAt}
                        to={el.endAt}
                        validator={
                            el.selected
                                ? el.startAt === undefined || el.endAt === undefined
                                    ? [this.validator, this.validatorDraft]
                                    : el.startAt > el.endAt
                                    ? [this.validator, this.validatorDraft]
                                    : null
                                : null
                        }
                        validatorsTo={`after_or_equal_time~${moment(el.startAt ? el.startAt : new Date())
                            .format('DD-MM-YYYY HH:mm')
                            .toString()}`}
                        onChange={(a, b, e) => {
                            this.handleChangeHour(a, b, e, el.enumValue);
                        }}
                        validators={'not_required'}
                        viewMode={'EDIT'}
                        disabled={!el.selected}
                        timeOnly
                        showIcon
                        placeholderFrom='HH:mm'
                        placeholderTo='HH:mm'
                        validateViewMode
                        dateFormatMoment='HH:mm'
                        validatorsToType='after_or_equal_time'
                    />
                </div>
            );
        });
    }
    handleCoordinatesChange(position) {
        console.log('handleCoordinatesChange', position);
        this.setState((prevState) => ({
            element: {
                ...prevState.element,
                latitude: position.lat,
                longitude: position.lng,
            },
        }));
    }
    markAsFound(geo) {
        let markerTable = [
            {
                position: {
                    lat: geo.coordinates[1],
                    lng: geo.coordinates[0],
                },
            },
        ];
        this.setState(
            {
                markers: markerTable,
                zoom: 16,
            },
            () => {
                console.log(this.state);
                this.handleCoordinatesChange(markerTable[0].position);
            }
        );
    }

    isValidCoordinate(txt) {
        return txt ? /^[0-9]*\.?[0-9]*$/.test(txt) : true;
    }

    setMarker() {
        const {element} = this.state;

        let markerTable = [
            {
                position: {
                    lat: element?.latitude ? element?.latitude : this.state.initialCoordinates.lat,
                    lng: element?.longitude ? element?.longitude : this.state.initialCoordinates.lng,
                },
            },
        ];

        this.setState({
            markers: markerTable,
            zoom: 16,
        });
    }

    handleMarkerDrag(coordinates, markerIndex) {
        console.log('handleMarkerDrag ', coordinates, markerIndex);
        this.handleCoordinatesChange(coordinates);
    }

    handleAddressChange(inputType, parameters, event, onAfterStateChange, stateField) {
        this.handleChange(inputType, parameters, event, onAfterStateChange, stateField);
        this.calculateCoordinates();
    }

    calculateCoordinates() {
        //musi byc wypelniony adres
        var duration = 1000;
        clearTimeout(this.inputTimer);

        this.inputTimer = setTimeout(() => {
            if (this.state.element?.streetNumber || this.state.element?.city) {
                this.blockUi();
                const {element} = this.state;
                this.geoSerivce
                    .calculateCoordinates(element.streetName, element.streetNumber, element.postalCode, element.city)
                    .then((geo) => {
                        this.unblockUi();
                        //dodanie markera i zoom na 16
                        console.log('znaleziono wspolrzedne obiektu ', geo);
                        this.markAsFound(geo);
                    })
                    .catch(() => {
                        console.log('nie znaleziono punktu');
                        //usuniecie markera
                        this.setState(
                            {
                                markers: [],
                                zoom: 6,
                            },
                            () => {
                                console.log(this.state);
                                this.handleCoordinatesChange({lat: null, lng: null});
                                this.unblockUi();
                            }
                        );
                    });
            }
        }, duration);
    }

    handleChangeCoordinates(inputType, parameters, event, onAfterStateChange, stateField) {
        if (this.isValidCoordinate(event.target?.value)) {
            HandleChangeUtils.handleChange(
                inputType,
                parameters,
                event,
                onAfterStateChange,
                stateField,
                this.handleChangeSetState,
                this.state
            );
        } else {
            this.showErrorMessage(t('partner.error.badCooridinateFormat'));
        }
    }

    renderDetails() {
        const {elementId, renderPrevLogo} = this.state;
        const uploadOptions = {
            icon: 'none',
            iconOnly: true,
            style: {width: '0px'},
            className: 'invisible',
        };
        const type = this.state?.type;
        return (
            <React.Fragment>
                {this.props.viewMode !== 'VIEW' && (
                    <InputSelectButtonComponent
                        id='type'
                        name='type'
                        colClass='col-12'
                        value={type}
                        options={this.state.partnerTypes}
                        label={t('partner.type')}
                        optionLabel='label'
                        stateField=''
                        onChange={this.handleChange}
                        viewMode={this.props.viewMode}
                        validator={this.props.validator}
                        validators='required'
                        validateViewMode
                    />
                )}
                <div className='col-md-12 col-sm-12'>
                    <div className='row mb-4'>
                        <div className='col-12 row'>
                            <div className='col-lg-4 col-md-12'>
                                <div className='row'>
                                    {this.props.viewMode !== 'VIEW' && this.state.type === 'STATIONARY' && (
                                        <InputCheckboxComponent
                                            id='showByCoordinate'
                                            name='showByCoordinate'
                                            labelOnRight
                                            label={t('partner.coordinate')}
                                            value={this.state.parterStationaryByCoordinate}
                                            validator={this.validator}
                                            validators='not_required'
                                            colClass='col-lg-12 col-md-12 col-sm-12'
                                            disabled={this.viewMode() === 'VIEW'}
                                            onChange={() =>
                                                this.setState({parterStationaryByCoordinate: !this.state.parterStationaryByCoordinate})
                                            }
                                            viewMode={'EDIT'}
                                        />
                                    )}

                                    <InputTextComponent
                                        id={`name`}
                                        name='name'
                                        label={t('partner.name')}
                                        colClass='col-lg-12 col-md-12'
                                        value={this.state.element?.name}
                                        validator={this.validator}
                                        validators='required|max:255'
                                        onChange={this.handleChange}
                                        viewMode={this.props.viewMode}
                                    />
                                    <InputTextComponent
                                        id={`email`}
                                        name='email'
                                        label={t('partner.email')}
                                        validators={'not_required|email|max:100'}
                                        colClass='col-lg-12 col-md-12'
                                        value={this.state.element?.email}
                                        onChange={this.handleChange}
                                        validator={this.validator}
                                        viewMode={this.props.viewMode}
                                    />
                                    <InputTextComponent
                                        id={`phoneNumber`}
                                        name='phoneNumber'
                                        label={t('partner.phoneNumber')}
                                        colClass='col-lg-12 col-md-12'
                                        validators={'not_required|phone|max:9|min:9'}
                                        value={this.state.element?.phoneNumber}
                                        validator={this.validator}
                                        onChange={this.handleChange}
                                        viewMode={this.props.viewMode}
                                    />

                                    <InputTextComponent
                                        id={`link`}
                                        name='link'
                                        label={t('partner.link')}
                                        colClass='col-lg-12 col-md-12'
                                        validators='not_required|url'
                                        value={this.state.element?.link}
                                        validator={this.validator}
                                        onChange={this.handleChange}
                                        viewMode={this.props.viewMode}
                                    />

                                    {type === types.STATIONARY && (
                                        <React.Fragment>
                                            {!this.state.parterStationaryByCoordinate ? (
                                                <React.Fragment>
                                                    <InputTextComponent
                                                        id={`city`}
                                                        name='city'
                                                        label={t('partner.city')}
                                                        colClass='col-lg-12 col-md-12'
                                                        value={this.state.element?.city}
                                                        validator={this.validator}
                                                        validators='required|max:255'
                                                        onChange={this.handleAddressChange}
                                                        viewMode={this.props.viewMode}
                                                    />
                                                    <InputTextComponent
                                                        id={`streetName`}
                                                        name='streetName'
                                                        label={t('partner.streetName')}
                                                        colClass='col-lg-12 col-md-12'
                                                        value={this.state.element?.streetName}
                                                        validator={this.validator}
                                                        validators='required|max:64'
                                                        onChange={this.handleAddressChange}
                                                        viewMode={this.props.viewMode}
                                                    />
                                                    <InputTextComponent
                                                        id={`streetNumber`}
                                                        name='streetNumber'
                                                        label={t('partner.streetNumber')}
                                                        colClass='col-lg-12 col-md-12'
                                                        value={this.state.element?.streetNumber}
                                                        validator={this.validator}
                                                        validators='required|max:64'
                                                        onChange={this.handleAddressChange}
                                                        viewMode={this.props.viewMode}
                                                    />
                                                    <InputTextComponent
                                                        id={`houseNumber`}
                                                        name='houseNumber'
                                                        label={t('partner.houseNumber')}
                                                        colClass='col-lg-12 col-md-12'
                                                        value={this.state.element?.houseNumber}
                                                        validator={this.validator}
                                                        validators='not_required'
                                                        onChange={this.handleAddressChange}
                                                        viewMode={this.props.viewMode}
                                                    />
                                                    <InputTextComponent
                                                        id={`postalCode`}
                                                        name='postalCode'
                                                        label={t('address.postalCode')}
                                                        colClass='col-lg-12 col-md-12'
                                                        value={this.state.element?.postalCode}
                                                        validators={`zipcode|required`}
                                                        onChange={this.handleAddressChange}
                                                        viewMode={this.props.viewMode}
                                                        validateViewMode
                                                    />
                                                </React.Fragment>
                                            ) : (
                                                <React.Fragment>
                                                    <InputTextComponent
                                                        id={`latitude`}
                                                        name='latitude'
                                                        label={t('partner.latitude')}
                                                        colClass='col-lg-12 col-md-12'
                                                        value={this.state.element?.latitude}
                                                        validator={this.validator}
                                                        validators='required'
                                                        onChange={this.handleChangeCoordinates}
                                                        onAfterStateChange={this.setMarker}
                                                        viewMode={this.props.viewMode}
                                                    />

                                                    <InputTextComponent
                                                        id={`longitude`}
                                                        name='longitude'
                                                        label={t('partner.longitude')}
                                                        colClass='col-lg-12 col-md-12'
                                                        value={this.state.element?.longitude}
                                                        validator={this.validator}
                                                        validators='required|number'
                                                        onChange={this.handleChangeCoordinates}
                                                        onAfterStateChange={this.setMarker}
                                                        viewMode={this.props.viewMode}
                                                    />
                                                </React.Fragment>
                                            )}
                                        </React.Fragment>
                                    )}
                                </div>
                            </div>
                            {type === types.STATIONARY && (
                                <div className='col-lg-8 col-md-12'>
                                    {/* <MapLeaflet
                                        key={'mapleaft'}
                                        class='map-container'
                                        markers={this.state.markers}
                                        initialCoordinates={this.state.initialCoordinates}
                                        zoom={this.state.zoom}
                                        draggable={this.props.viewMode === 'NEW' || this.props.viewMode === 'EDIT'}
                                        handleMarkerDrag={this.handleMarkerDrag.bind(this)}
                                    /> */}
                                </div>
                            )}
                        </div>
                    </div>
                    {type === types.STATIONARY && this.renderAvailabilityHoursPerDay()}
                </div>
                <div className='form-group'>
                    <div className=' row p-label'>
                        <CustomLabel
                            label={
                                this.props.viewMode === 'VIEW' ? t('partner.logotype') : t('partner.logotype') + t('global.requiredSign')
                            }
                        />
                    </div>

                    <DivContainer rendered={this.props.viewMode !== 'VIEW'}>
                        <FileUpload
                            ref={this.fileUploadRefComponent}
                            uploadLabel={t('file.upload')}
                            chooseLabel={t('file.choose')}
                            cancelLabel={t('file.cancel')}
                            multiple={false}
                            customUpload
                            className='col-lg-12'
                            uploadOptions={uploadOptions}
                            onSelect={this.onSelect}
                            onRemove={this.onClear}
                            onClear={this.onClear}
                            uploadHandler={() => {}}
                            accept='*'
                            maxFileSize={this.state.imgMaxSizeParameter}
                            invalidFileSizeMessageSummary={t('global.invalidFileSizeSummary')}
                            invalidFileSizeMessageDetail={t('global.invalidFileSizeDetails') + this.state.fileSizeToTranslation}
                        />
                    </DivContainer>
                    <DivContainer className='col-lg-6' rendered={elementId != null && renderPrevLogo}>
                        <img
                            src={`${this.service.getPath()}/logo/${this.state.element?.logo?.uuid}?token=${this.authService?.getToken()}`}
                            alt='Logo icon'
                            className='product-image'
                            style={{height: '150px', width: 'auto'}}
                        />
                    </DivContainer>
                </div>
                <InputTextEditorComponent
                    colClass='col-xl-12'
                    id='description'
                    name='description'
                    value={this.state?.element?.translations[this.state?.locale]?.description}
                    key={`description-${this.props.viewMode}`}
                    label={t('partner.description')}
                    validator={this.validator}
                    validators='required'
                    rows='5'
                    onChange={this.handleChange}
                    viewMode={'EDIT'}
                    autoResize
                    editorRef={this.editorRef}
                    externalPhotos={true}
                    photos={this.state.element.photos}
                    photoUrl={`${this.service.getPath()}/photo/${elementId}`}
                    photoUploadUrl={`${this.fileUploadService.getPath()}/`}
                    photoLabel='fileName'
                    photoName='uuid'
                    handleError={this.onUploladError}
                    restrictExt={false}
                    token={this.authService.getToken()}
                    photoVarName='photos'
                    stateField={`element.translations[${this.state.locale}]`}
                    disabled={this.props.viewMode === 'VIEW'}
                />
            </React.Fragment>
        );
    }
    uploadHandler = async () => {
        this.blockUi();
        const selectedFile = this.state.selectedFile;
        const formData = new FormData();
        formData.append('file', selectedFile);

        if (ImageUtils.notValidImageFormat(selectedFile)) {
            this.showErrorMessage(t('image.notValidImageType'));
            this.fileUploadRefComponent.current.clear();
            this.unblockUi();
            return;
        }

        this.fileUploadService
            .uploadAttachemnt(formData)
            .then((uploadedFile) => {
                this.setState({uploadedFile});
                this.unblockUi();
            })
            .catch(() => {
                this.showErrorMessage(t('message.tooLargeFileSize'));
                this.unblockUi();
            });
    };

    onSelect = (e) => {
        this.setState(
            {
                selectedFile: e.files[0],
                renderPrevLogo: false,
            },
            () => {
                this.uploadHandler();
            }
        );
    };

    onClear = () => {
        this.setState({
            selectedFile: undefined,
            uploadedFile: undefined,
            renderPrevLogo: true,
        });
    };
}

PartnerContainer.defaultProps = {
    backUrl: '/partner-list',
    editUrl: '/partner/edit',
    detailUrl: '/partner/details',
    lazy: true,
};

PartnerContainer.propTypes = {
    backUrl: PropTypes.string,
    cancelUrl: PropTypes.string,
    editUrl: PropTypes.string,
    detailUrl: PropTypes.string,
};

export default withRouter(withTranslation()(PartnerContainer));
